import React, { useEffect, useMemo, useState } from "react";
import { Check, X, Timer } from "lucide-react";
import { pick } from "./GameShell";

const Tap = ({ game, level, lang, onFinish }) => {
  const lvl = game.levels[level - 1] || {};
  const targets = useMemo(
    () => [...(lvl.targets || game.data.targets)].sort(() => Math.random() - 0.5),
    [lvl, game]
  );
  const seconds = lvl.seconds || game.data.seconds || 25;
  const pointsPerLevel = lvl.points || game.points;

  const [pos, setPos] = useState(0);
  const [score, setScore] = useState(0);
  const [timeLeft, setTimeLeft] = useState(seconds);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (done) return;
    const t = setInterval(() => {
      setTimeLeft((s) => {
        if (s <= 1) {
          clearInterval(t);
          setDone(true);
          return 0;
        }
        return s - 1;
      });
    }, 1000);
    return () => clearInterval(t);
  }, [done]);

  useEffect(() => {
    if (done) {
      const earned = Math.min(pointsPerLevel, Math.max(0, score * 5));
      onFinish({ score, points: earned, total: targets.length });
    }
    // eslint-disable-next-line
  }, [done]);

  const tap = (t) => {
    if (done) return;
    if (t.good) setScore((s) => s + 1);
    else setScore((s) => Math.max(0, s - 1));
    setPos((p) => (p + 1) % targets.length);
  };
  const skip = () => {
    if (done) return;
    setPos((p) => (p + 1) % targets.length);
  };

  const current = targets[pos];
  return (
    <div data-testid={`game-tap-${game.id}`}>
      <div className="flex items-center justify-between mb-3 text-sm">
        <span className="bs-amber font-bold">
          {lang === "es" ? "Aciertos" : "Score"}: {score}
        </span>
        <span className="bs-chip">
          <Timer className="w-3.5 h-3.5" />
          {timeLeft}s
        </span>
      </div>
      <div
        className="h-44 sm:h-56 rounded-3xl flex items-center justify-center text-center p-4 mb-4 transition-colors"
        style={{ background: current?.color ? current.color + "33" : "rgba(255,255,255,0.06)" }}
      >
        <p className="text-xl sm:text-3xl font-extrabold text-white drop-shadow-lg leading-tight">
          {pick(lang, current)}
        </p>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <button
          onClick={() => tap(current)}
          className="bs-cta justify-center w-full"
          data-testid="tap-take"
        >
          <Check className="w-4 h-4" />
          {lang === "es" ? "¡Buena!" : "Good!"}
        </button>
        <button onClick={skip} className="bs-chip justify-center w-full py-3" data-testid="tap-skip">
          <X className="w-4 h-4" />
          {lang === "es" ? "Saltar" : "Skip"}
        </button>
      </div>
    </div>
  );
};

export default Tap;
